module.exports = __webpack_public_path__ + "static/media/circle.efc29e21.png";